import React from "react";
import moment from "moment";
import _ from "lodash";

import {isNotAvailable, TRANSACTION_TYPE} from "../../../../../constants";

import {
  SavingPlanSettings
} from "../../../../../../RiskProfiling/components/StepContent/components/step/ProductSelectionStepsV2/components/SavingPlanSetting";
import {DATE_FORMAT} from "../../../../../../../utils/constants";

const _formatDate = (value) => value ? moment(value).format(DATE_FORMAT) : value;

const MODAL_TITLES = {
  create: "einrichten",
  edit: "bearbeiten",
  delete: "löschen",
}

const SavingPlanSettingsForTrading = ({ item, options, classes }) => {
  const handleDateValidity = React.useCallback(
    (date) => {
      if (!options.fromDateOptions || _.isEmpty(options.fromDateOptions)) return true;
      return isNotAvailable(
        date,
        options.fromDateOptions.map((o) => o.value),
        options.maxStartDate ? options.maxStartDate(item) : undefined
      );
    },
    [options.fromDateOptions, options.maxStartDate, item]
  );

  const isDelete = item.action === "delete";

  const customClasses = item.is_changed && item.action !== "create" ? {
    rotation: _.get(item, "changes.rotation") && classes.changedLabel,
    from_date: _.get(item, "changes.from_date") && classes.changedLabel,
    till_date: _.get(item, "changes.till_date") && classes.changedLabel,
  } : {}

  return (
    <SavingPlanSettings
      currentPlan={({
        rotation: {value: item.rotation, label: item.rotationLabel},
        rotation_error: _.get(item.errors, 'rotation'),
        from_date: _formatDate(item.from_date),
        from_date_error: _.get(item.errors, 'from_date'),
        till_date: _formatDate(item.till_date),
        till_date_error: _.get(item.errors, 'till_date'),
        populate: false,
      })}
      item={item}
      onChange={options.handlePlanDataChange}
      rotationOptions={options.rotationOptions || []}
      handleDateValidity={handleDateValidity}
      fromDateDisabled={isDelete && !options.deleteDateEnabled}
      endDateDisabled={isDelete || !options.tillDateEnabled}
      rotationDisabled={isDelete}
      convertFromForm={(form) => ({
        rotation: form.rotation.value,
        rotationLabel: form.rotation.label,
        from_date: form.from_date,
        till_date: form.till_date,
      })}
      customClasses={customClasses}
      modalTitle={`${TRANSACTION_TYPE[options.paymentPlanTransactionKey]} ${MODAL_TITLES[item.action]}`}
    />
  );
};

export default SavingPlanSettingsForTrading;
